import styled from 'styled-components';

export const ActionButton = styled.button`
    border-radius: 10px;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.12);
    background: linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%);
    color: #ffffff;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25);

    &:active { 
      filter: brightness(0.98);
      color: #ffffff;
    }
    &:focus { outline: 0; }
`;
